import {BCMSRecord ,BCMSRecordProperty} from "bcms-react"; 

/**
* @class Profile
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.profile[0];
* const profile = new Profile(record);
* @property {STRING} _id - The id of the profile.
*/
export default class Profile extends BCMSRecord {
    _id
    _name
    _profilePickerName
    _type

    constructor(record) {     
      super(record) 
    }
  }
  Profile.define({
    "recordType": "profiles",
    "recordIDProp":"id",
    "className" : "Profile",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {STRING} - gets the id 
         * @property set {STRING} - sets the id 
         * @memberof Profile
         */
        BCMSRecordProperty.mapToString("id","_id"),

        /** 
         * @name name
         * @instance
         * @property get {STRING} - gets the name
         * @property set {STRING} - sets the name
         * @memberof Profile
         */
        BCMSRecordProperty.mapToString("name","_name"),

        /** 
         * @name profilePickerName
         * @instance
         * @property get {STRING} - gets the profilePickerName value
         * @property set {STRING} - sets the profilePickerName value
         * @memberof Profile
         */
        BCMSRecordProperty.mapToString("profilePickerName", "_profilePickerName"),

        /** 
         * @name type
         * @instance
         * @property get {STRING} - gets the type
         * @property set {STRING} - sets the type
         * @memberof Profile
         */
        BCMSRecordProperty.mapToString("type","_type"),
    ]  
})




